var map = {
	"./AUD.png": 3030,
	"./CAD.png": 110,
	"./CHF.png": 1148,
	"./EUR.png": 3111,
	"./GBP.png": 4559,
	"./IND.png": 5477,
	"./JPY.png": 1222,
	"./Logo-FLV.png": 2376,
	"./NZD.png": 2903,
	"./USD.png": 3180,
	"./logo.png": 6949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5675;